import { Injectable } from '@angular/core';
import { EntityDto, Rest, RestService } from '@ralba/shared';
import { TenancyRequestDto } from '../dto';

@Injectable({ providedIn: 'root' })
export class ManagePayrollHttpApiService {
  constructor(private rest: RestService) {}

  public deletePayroll(params: TenancyRequestDto<EntityDto>) {
    const request: Rest.Request<null> = {
      method: 'DELETE',
      url: '/api/manage/payroll',
      params,
    };
    return this.rest.request<null, Rest.AbpResponse<null>>(request);
  }
}
